export default __webpack_public_path__ + "static/media/42_desktop.91d98e0e.jpg";